/**
 * React Bits Pro — Features 3
 * Opposite-scrolling vertical marquees with hover-pause and viewport optimization
 */

(function () {
  'use strict';

  class SeznikFeatures3 {
    constructor(element) {
      this.root = element;
      this.speed = parseInt(this.root.getAttribute('data-scroll-speed'), 10) || 28;
      this.marqueeTracks = this.root.querySelectorAll('.features3-marquee-track');
      this.isInView = true;
      this.isHovered = false;

      this.init();
    }

    init() {
      // Apply configured speed to CSS variable
      this.root.style.setProperty('--f3-speed', `${this.speed}s`);

      // Mouseenter & mouseleave on marquees wrapper to stop scroll immediately on hover
      const marqueeWrapper = this.root.querySelector('.features3-marquees-wrapper');
      if (marqueeWrapper) {
        marqueeWrapper.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.marqueeTracks.forEach((track) => {
            track.style.animationPlayState = 'paused';
          });
        });

        marqueeWrapper.addEventListener('mouseleave', () => {
          this.isHovered = false;
          if (this.isInView) {
            this.marqueeTracks.forEach((track) => {
              track.style.animationPlayState = 'running';
            });
          }
        });
      }

      // Performance optimization: Pause animations when off-screen
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.isInView = true;
                if (!this.isHovered) {
                  this.marqueeTracks.forEach((track) => {
                    track.style.animationPlayState = 'running';
                  });
                }
              } else {
                this.isInView = false;
                this.marqueeTracks.forEach((track) => {
                  track.style.animationPlayState = 'paused';
                });
              }
            });
          },
          { threshold: 0.1 }
        );

        this.observer.observe(this.root);
      }
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  // Initialize on DOM Ready
  function initAllFeatures3() {
    const featureElements = document.querySelectorAll('.seznik-features3:not([data-features3-initialized])');
    featureElements.forEach((el) => {
      el.setAttribute('data-features3-initialized', 'true');
      el._features3Instance = new SeznikFeatures3(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeatures3);
  } else {
    initAllFeatures3();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.seznik-features3')) {
      const section = event.target.querySelector('.seznik-features3');
      if (section && !section._features3Instance) {
        section.setAttribute('data-features3-initialized', 'true');
        section._features3Instance = new SeznikFeatures3(section);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('.seznik-features3')) {
      const section = event.target.querySelector('.seznik-features3');
      if (section && section._features3Instance) {
        section._features3Instance.destroy();
      }
    }
  });
})();
